<template>
  <div>
    <div class=" w-full mt-2">
      <p class="font-black text-xs mb-2 uppercase">
         Other Benefits
      </p>
      <div class="line"></div>
    </div>
    <table aria-label="other benefits table" class=" w-full">
      <thead>
        <tr>
          <th id="0">#</th>
          <th class=" uppercase" v-for="(header, index) in headers" :key="index" :id="index">
            <p>{{ header.title }}</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, i) in otherBenefitData" :key="i" class="tableBody text-sm" style="height: 48px; ">
          <td>
            {{ i + 1 }}
          </td>
          <td>
            {{ data.payItem.name }}
          </td>
          <td>
            {{ Capitalize(data.payType) }}
          </td>
          <td>
            {{ data.rateType.label }}
          </td>
          <td>
            <c-text v-if="data.isEdit" placeholder="" type="number" v-model="data.rateValue" :disabled="!canEdit" />
            <span v-else>
              {{`${data.rateValue}%`}}
            </span>
          </td>
          <td>
            {{ convertToCurrency(data.actualAmount) }}
          </td>
          <td>
            <div v-if="data.allowValueFormulaOverride">
              <div v-if="data.isEdit" @click="editRateValue(i)">
                <icon icon-name="close-icon" size="s" :class="canEdit ? `w-4 h-4 cursor-pointer` : `w-4 h-4`"/>
              </div>
              <div v-else-if="!data.isEdit" @click="editRateValue(i)">
                <icon icon-name="red-edit" size="s" :class="canEdit ? `w-4 h-4 cursor-pointer` : `w-4 h-4`"/>
              </div>
            </div>
            <div v-else>
              <icon icon-name="red-padlock" size="s" class="w-5 h-5"/>
            </div>
          </td>
        </tr>
        <tr class="h-7" />
      </tbody>
    </table>
  </div>
</template>

<script>
import CText from "@scelloo/cloudenly-ui/src/components/text";
import { mapState } from "vuex";

export default {
  components: { CText },
  props: {
    otherBenefitData: {
      type: Array,
      default() {
        return [];
      }
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { title: "pay item" },
        { title: "pay type" },
        { title: "rate type" },
        { title: "rate (%)" },
        { title: "amount (₦)" },
        { title: " " }
      ]
    };
  },
  computed: {
    ...mapState({
      employeeDetails: state => state.employee.allEmployeeDetails
    }),
    totalAmount() {
      let result = 0;
      let number = 0;
      this.otherBenefitData.forEach(element => {
        number = parseFloat(element.amount.split(",").join(""));
        result += number;
      });
      result = result.toLocaleString();
      return result;
    }
  },
  methods: {
    editRateValue(i){
      this.$emit('edit-RateValue', i)
    },
  }
};
</script>
<style scoped>
.line{
  border: 0.5px solid #00000029;
  width: 100%;
  height: 0;
  margin: 10px auto;
  border-radius: 10px;
  padding: 0;
}
</style>
